import { axiosInstances } from 'utilities/axios/Instances/axios.instances';

const getAllocations = () => {
  return axiosInstances.withAuthToken().get(`/allocations`);
};
export const allocationsService = { getAllocations };
